// this file contains only methods that should be used globally
import axios from "axios";
import { Notify, exportFile, QSpinnerGears, Dialog } from "quasar";
import store from "./ts-store";

export default {
  async downloadContent(contentId, name) {
    const loading = this.loadingNotify("Downloading...");
    try {
      const response = await axios.get(store.getters.getApi + "mediamanagement/download-file", { params: { contentId: contentId }, responseType: "arraybuffer" });
      loading();
      console.log(response);
      const status = exportFile(name, response.data);
      if (status) {
        // browser allowed it
        this.successNotify("Download complete");
        return status;
      } else {
        // browser denied it
        this.errorNotify("Your browser denied the download. You can try downloading it in the edit menu.");
        return status;
      }
    } catch (err) {
      console.log(err);
      this.errorNotify("Download failed. You can try downloading it in the edit menu.");
    }
    loading();
  },

  async downloadContents(contents) {
    const promiseList = [];
    contents.forEach((content) => {
      promiseList.push(this.downloadContent(content.id, content.name));
    });

    await Promise.all(promiseList);
  },

  async deleteFiles(contents, inUsePl) {
    const contentIds = [];
    contents.forEach((content) => {
      if (content.contentGroup) {
        const subContentGroupIds = [];
        content.contentGroup.forEach((subcontent) => {
          subContentGroupIds.push(subcontent.id);
        });

        try {
          store
            .dispatch("deleteMediaFile", {
              contentId: subContentGroupIds,
              groupId: content.contentGroup[0].contentGroupId,
            })
            .then(() => {
              return true;
            });
        } catch (error) {
          console.log(error);
          return false;
        }
      } else {
        contentIds.push(content.id);
      }

      if (inUsePl >= 0) {
        inUsePl.forEach((playlist) => {
          let contentIds = playlist.contentIds;
          console.log(contentIds);

          for (let i = 0; i < contentIds.length; i++) {
            const id = contentIds[i];

            if (content.contentGroupId && id === content.contentGroupId) {
              contentIds.splice(i, 1);
              break;
            } else if (content.id && id === content.id) {
              contentIds.splice(i, 1);
              break;
            }
          }

          try {
            store.dispatch("updatePlaylistContentV2", {
              content: contentIds,
              playlistID: playlist.ID,
            });
          } catch (error) {
            console.log(error.response.data.msg);
          }
        });
      }
    });

    try {
      store.dispatch("deleteMediaFile", { contentId: contentIds }).then(() => {
        return true;
      });
    } catch (error) {
      console.log(error);
      return false;
    }

    this.successNotify("Content has been deleted.");
  },

  deviceInStandby(device) {
    const currentTime = new Date(Date());
    const playlists = store.getters.getDeviceAssignedPlaylistsByID(device.DID);
    let inStandby = false;

    if (playlists.length > 0) {
      // check every playlist
      for (let i = 0; i < playlists.length; i++) {
        const playlist = playlists[i];

        // check if playlist has schedules
        if (playlist.schedules.length > 0) {
          // every schedule
          for (let j = 0; j < playlist.schedules.length; j++) {
            const schedule = playlist.schedules[j];

            if (this.isInDateRange(schedule.StartDate, schedule.StopDate)) {
              const dayInt = currentTime.getDay();
              const dayNames = ["SO", "MO", "DI", "MI", "DO", "FR", "SA"];

              // get current day name
              const keys = Object.keys(schedule).filter((k) => k.startsWith(dayNames[dayInt]));

              // get start and stop date
              let startDate;
              let stopDate;
              keys.forEach((key) => {
                const entry = schedule[key];
                const keysDate = new Date(Date());
                keysDate.setHours(entry.split(":")[0]);
                keysDate.setMinutes(entry.split(":")[1]);

                // check if this key is a start or stop time
                if (key.includes("START")) {
                  startDate = keysDate;
                } else {
                  stopDate = keysDate;
                }
              });

              // check if current time is between start and stop time
              if (currentTime > startDate && currentTime < stopDate) {
                return false;
              } else {
                inStandby = true;
              }
            } else {
              inStandby = true;
            }
          }
        } else {
          inStandby = true;
          break;
        }
      }
    } else {
      inStandby = true;
    }

    return inStandby;
  },

  isInDateRange(startDate, stopDate) {
    if (startDate == null || stopDate == null) return true;

    const currDate = new Date(Date());
    currDate.setHours(0, 0, 0, 0);

    const startDateObj = new Date(startDate);
    startDateObj.setHours(0, 0, 0, 0);

    const stopDateObj = new Date(stopDate);
    stopDateObj.setHours(0, 0, 0, 0);

    return currDate >= new Date(startDateObj) && currDate <= new Date(stopDateObj);
  },

  hasFeature(featureId) {
    const feature = store.getters.getUser.features.find((f) => {
      return f.featureId === featureId;
    });
    if (feature) {
      return feature.enabled;
    } else {
      return false;
    }
  },

  errorNotify(msg) {
    Notify.create({
      message: msg,
      icon: "check_circle_outline",
      position: "top",
      type: "negative",
      width: "30%",
      timeout: msg.length * 85,
    });
  },
  successNotify(msg) {
    Notify.create({
      message: msg,
      icon: "check_circle_outline",
      position: "top",
      type: "positive",
      width: "30%",
      timeout: msg.length * 85,
    });
  },
  warnNotify(msg) {
    Notify.create({
      message: msg,
      icon: "check_circle_outline",
      position: "top",
      type: "warning",
      width: "30%",
      timeout: msg.length * 85,
    });
  },
  loadingNotify(msg) {
    return Notify.create({
      spinner: QSpinnerGears,
      position: "top",
      message: msg,
      timeout: 0,
    });
  },
  createDialog(options) {
    return Dialog.create(options);
  },
};